import ServiceGraphQL from 'src/service/gql-service';
import { validateGlobalPay } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const ValidateGlobalPay = (variables) => {
  const params = {
    query: validateGlobalPay.QUERY,
    variables
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      const responseData = res.data.validateGlobalPay;
      if (responseData.code === '00') {
        return responseData;
      } else {
        throw new Error([responseData.msg, responseData.desc].filter((e) => !!e).join(','));
      }
    })
    .catch((err) => {
      throw err;
    });
};
